// angular
// 	.module("HeroPRO")
// 	.controller("PaceCredentialController", pccontroller);

import _ from 'lodash';
import './paceCredential.scss';

/* @ngInject */
export default function paceCredentialController(UserData, AccountsFactory, ModalService, PermissionsFactory, $rootScope, HISWizardFactory, $state) {
    const vm = this;

    vm.isSolicitor = false;
    vm.advertiserRequirements_HasTraining = false;
    vm.advertiserRequirements_Eligible = false;
    vm.solicitorRequirements_HasTraining = false;
    vm.solicitorRequirements_HasLicenseNumber = false;
    vm.solicitorRequirements_Eligible = false;
    vm.HISLicenseNumber = 0;
    vm.trainingDaysRemaining = 0;

    init();

    /*= =======================================
   =            Public Functions            =
   ======================================== */


    vm.openContractorUserLicenseRegistrationModal = function () {
        const modal = ModalService.launchLgModal({
            templateUrl: 'app/accounts/user/personalInformation/contractorUserLicenseRegistration/contractorUserLicenseRegistration.html',
            windowClass: 'contractor-user-license-registration',
            controller: 'ContractorUserLicenseRegistrationController',
            controllerAs: 'contractorUserLicenseRegistration',
            size: 'full-screen',
            resolve: {
                selectedUser() {
                    return vm.userProfile;
                },
            },
        });

        modal.result.then((user) => {
            if (user) {
                vm.userProfile = user;
                vm.hisComplete = vm.userProfile.Licenses !== null && _.findWhere(vm.userProfile.Licenses, {
                    LicenseTypeId: 1,
                }) !== undefined;
                $rootScope.$broadcast('RefreshPermissions');
                window.location.reload();
            }
        });
    };


    vm.openStatusComparisonModal = function () {
        const modal = ModalService.launchLgModal({
            templateUrl: 'app/accounts/user/paceCredential/modals/ParticipantVsCertifiedProfessionalComparison.html',
            windowClass: 'comparison-modal',
            size: 'lg',
            controller: 'ParticipantVsCertifiedProfessionalComparisonController',
            controllerAs: 'ParticipantVsCertifiedProfessionalComparisonController',
        });
    };


    vm.GoToTraining = function (trainingType) {
        if (trainingType === 'advertiser') {
            trainingType = 2;
        } else if (trainingType === 'solicitor') {
            trainingType = 1;
        }

        const params = {
            overrideTrainingType: trainingType,
        };

        AccountsFactory.getContractorUserHISTrainingRedirectURI(params).then((response) => {
            // console.log(response);
            if (response && response.data && response.data.Data) {
                const data = response.data.Data;
                if (data.RedirectURI) {
                    window.open(data.RedirectURI), '_blank';
                }
            }
        });
    };

    vm.adjustContractorUserHISStatus = function (statusToSwitchTo) {
        let hisStatusType = 1;

        if (statusToSwitchTo === 'advertiser') {
            hisStatusType = 1;
        } else if (statusToSwitchTo === 'solicitor') {
            hisStatusType = 2;
        }

        const params = {
            HISStatusType: hisStatusType,
        };

        AccountsFactory.adjustContractorUserHISStatus(params).then((response) => {
            if (response && response.data) {
                const data = response.data;
                window.location.reload();
            }
        });
    };

    /* -----  End of Public Functions  ------*/

    /*= =======================================
   =            Private Functions            =
   ======================================== */

    function getContractorUserHISRequirementsStatus() {
        vm.isLoading = true;
        AccountsFactory.getContractorUserHISRequirementsStatus().then((response) => {
            // console.log(response);
            let data;
            if (response && response.data && response.data.Data) {
                data = response.data.Data;
            }


            if (data && data.AdvertiserRequirements) {
                vm.advertiserRequirements_HasTraining = data.AdvertiserRequirements.HasTraining;
                vm.advertiserRequirements_Eligible = data.AdvertiserRequirements.Eligible;
            }
            if (data) {
                vm.isSolicitor = data.IsSolicitor;
                vm.HISLicenseNumber = data.LicenseNumber;
            }
            if (data && data.SolicitorRequirements) {
                vm.solicitorRequirements_HasTraining = data.SolicitorRequirements.HasTraining;
                vm.solicitorRequirements_HasLicenseNumber = data.SolicitorRequirements.HasLicenseNumber;
                vm.solicitorRequirements_Eligible = data.SolicitorRequirements.Eligible;
            }

            if ((vm.isSolicitor && !vm.solicitorRequirements_HasTraining) || (!vm.isSolicitor && !vm.advertiserRequirements_HasTraining)) {
                HISWizardFactory.openHISWizardModal(false);
                $state.go('accounts', { accountsPage: 'myprofile', accountId: null });
            }

            vm.isLoading = false;
        });
    }

    function getContractorUser() {
        AccountsFactory.getContractorUser().then((response) => {
            if (response.data.Data !== undefined || response.data.Data !== null) {
                vm.userProfile = response.data.Data;
                vm.hisComplete = vm.userProfile.Licenses !== null && _.findWhere(vm.userProfile.Licenses, {
                    LicenseTypeId: 1,
                }) !== undefined;
            }
        });
    }

    function init() {
        getContractorUserHISRequirementsStatus();
        getContractorUser();
        // getContractorUserTraining();
    }

    // function getContractorUserTraining() {
    //     AccountsFactory.getContractorUserTrainings().then((response) => {
    //         vm.trainings = response.data.Data;
    //         vm.training30Min = _.findWhere(vm.trainings, { PersonIdentityTrainingTypeId: 1 });
    //         vm.training30MinComplete = vm.training30Min !== undefined && vm.training30Min.PersonIdentityTrainingStatusId === 3;
    //         vm.training6Hours = _.findWhere(vm.trainings, { PersonIdentityTrainingTypeId: 2 });
    //         vm.training6HoursComplete = vm.training6Hours !== undefined && vm.training6Hours.PersonIdentityTrainingStatusId === 3;
    //     });
    // }
}



// WEBPACK FOOTER //
// ./src/app/accounts/user/paceCredential/paceCredentialController.js